import React from 'react';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import '../css/bootstrap.css';
import '../css/dashboard.css';
import '../css/gestion-pacientes.css';
import Loading from '../loading.gif';
import Url from './funciones_extras';
import alertify from 'alertifyjs';
import Paginador from './Paginador';

const REGISTROS_POR_PAGINA = 8;

class ListadoPacientes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pacientes: [],
      paginaActual: 1,
      ultimaPagina: 1,
      totalPacientes: 0,
      cantidadRegistrados: 0,
      enBusqueda: false,
      pacientesBusqueda: [],
      cargando: false,
      terminoBusqueda: '',
      todosPacientes: [],
      paginacionCliente: false,
      fotosFallidas: {},
      exportandoCsv: false
    };
  }

  componentDidMount() {
    this.cargarPacientes(1);
    this.cargarTotalRegistrados();
  }

  normalizarPacientes = (lista) => {
    return (lista || []).map((paciente) => {
      if (paciente.doctor == null) {
        return {
          ...paciente,
          doctor: {
            id: 1,
            nombre: 'No tiene',
            apellido: 'doctor registrado'
          }
        };
      }
      return paciente;
    });
  };

  cargarTotalRegistrados = () => {
    Axios.get(`${Url.url_base}/api/cantidad_de_pacientes`)
      .then((res) => {
        this.setState({ cantidadRegistrados: res.data.cantidad_pacientes || 0 });
      })
      .catch(() => {});
  };

  aplicarPaginaCliente = (todos, pagina) => {
    const lista = this.normalizarPacientes(todos);
    const ultimaPagina = Math.max(1, Math.ceil(lista.length / REGISTROS_POR_PAGINA));
    const paginaSegura = Math.min(Math.max(1, pagina), ultimaPagina);
    const inicio = (paginaSegura - 1) * REGISTROS_POR_PAGINA;
    return {
      todosPacientes: lista,
      pacientes: lista.slice(inicio, inicio + REGISTROS_POR_PAGINA),
      paginaActual: paginaSegura,
      ultimaPagina,
      totalPacientes: lista.length,
      paginacionCliente: true
    };
  };

  cargarPacientes = (pagina = 1) => {
    this.setState({ cargando: true });

    const config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'content-type': 'application/json'
      }
    };

    Axios.get(
      `${Url.url_base}/api/paciente?page=${pagina}&per_page=${REGISTROS_POR_PAGINA}`,
      config
    )
      .then((res) => {
        const body = res.data;

        if (Array.isArray(body)) {
          this.setState({
            ...this.aplicarPaginaCliente(body, pagina),
            enBusqueda: false,
            pacientesBusqueda: [],
            terminoBusqueda: '',
            cargando: false
          });
          return;
        }

        const lista = body.data || [];
        const tieneMeta = body.last_page != null && body.total != null;
        this.setState({
          pacientes: this.normalizarPacientes(lista),
          todosPacientes: [],
          paginacionCliente: false,
          enBusqueda: false,
          pacientesBusqueda: [],
          terminoBusqueda: '',
          paginaActual: body.current_page || pagina,
          ultimaPagina: tieneMeta ? body.last_page : Math.max(1, Math.ceil(lista.length / REGISTROS_POR_PAGINA)),
          totalPacientes: tieneMeta ? body.total : lista.length,
          cargando: false
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargando: false });
        alertify.error('Error al cargar pacientes');
      });
  };

  getPacientesVisibles = () => {
    if (this.state.enBusqueda) {
      const inicio = (this.state.paginaActual - 1) * REGISTROS_POR_PAGINA;
      return this.state.pacientesBusqueda.slice(inicio, inicio + REGISTROS_POR_PAGINA);
    }
    return this.state.pacientes;
  };

  irAPagina = (pagina) => {
    if (pagina < 1 || pagina > this.state.ultimaPagina) return;
    if (this.state.enBusqueda) {
      this.setState({ paginaActual: pagina });
      return;
    }
    if (this.state.paginacionCliente) {
      const inicio = (pagina - 1) * REGISTROS_POR_PAGINA;
      this.setState({
        paginaActual: pagina,
        pacientes: this.state.todosPacientes.slice(inicio, inicio + REGISTROS_POR_PAGINA)
      });
      return;
    }
    this.cargarPacientes(pagina);
  };

  buscarPaciente = (e) => {
    const termino = (e.target.value || '').trim();
    this.setState({ terminoBusqueda: e.target.value });

    if (!termino) {
      this.setState({ enBusqueda: false, pacientesBusqueda: [], paginaActual: 1 }, () => {
        this.cargarPacientes(1);
      });
      return;
    }

    Axios.get(`${Url.url_base}/api/buscar_paciente/${encodeURIComponent(termino)}`)
      .then((res) => {
        const lista = this.normalizarPacientes(res.data);
        this.setState({
          enBusqueda: true,
          pacientesBusqueda: lista,
          pacientes: [],
          paginaActual: 1,
          ultimaPagina: Math.max(1, Math.ceil(lista.length / REGISTROS_POR_PAGINA)),
          totalPacientes: lista.length
        });
      })
      .catch((error) => {
        console.log(error);
        alertify.error('Error en la búsqueda');
      });
  };

  formatearFecha = (fecha) => {
    if (!fecha) return '—';
    try {
      return new Date(fecha).toLocaleDateString('es-DO');
    } catch (_) {
      return fecha;
    }
  };

  inicialesPaciente = (nombre, apellido) => {
    const n = (nombre || '').trim().charAt(0).toUpperCase();
    const a = (apellido || '').trim().charAt(0).toUpperCase();
    return (n + a) || '?';
  };

  onErrorFotoPaciente = (pacienteId) => {
    this.setState((prev) => ({
      fotosFallidas: { ...prev.fotosFallidas, [pacienteId]: true }
    }));
  };

  renderAvatarPaciente = (paciente) => {
    const iniciales = this.inicialesPaciente(paciente.nombre, paciente.apellido);
    const urlFoto = Url.url_storage_publico(paciente.foto_paciente);
    const mostrarFoto = urlFoto && !this.state.fotosFallidas[paciente.id];

    if (mostrarFoto) {
      return (
        <img
          src={urlFoto}
          alt={`${paciente.nombre || ''} ${paciente.apellido || ''}`.trim()}
          className="listado-pacientes-avatar listado-pacientes-avatar--foto"
          onError={() => this.onErrorFotoPaciente(paciente.id)}
        />
      );
    }

    return <span className="listado-pacientes-avatar">{iniciales}</span>;
  };

  renderPaginador = () => (
    <Paginador
      paginaActual={this.state.paginaActual}
      ultimaPagina={this.state.ultimaPagina}
      total={this.state.totalPacientes}
      registrosPorPagina={REGISTROS_POR_PAGINA}
      cargando={this.state.cargando}
      enBusqueda={this.state.enBusqueda}
      onIrAPagina={this.irAPagina}
    />
  );

  exportarCsv = () => {
    if (!Url.puedeExportarPacientesCsv()) {
      alertify.error('No tiene permiso para exportar pacientes.');
      return;
    }
    if (this.state.exportandoCsv) return;
    this.setState({ exportandoCsv: true });
    Url.exportar_pacientes_csv()
      .then((result) => {
        alertify.success(`${result.total} pacientes exportados a ${result.filename}`);
      })
      .catch((error) => {
        if (error && (error.message === 'cancelado' || error.message === 'sin_permiso')) return;
      })
      .finally(() => {
        this.setState({ exportandoCsv: false });
      });
  };

  render() {
    const lang = Url.lenguaje.citas_c || {};
    const visibles = this.getPacientesVisibles();

    return (
      <div className="col-12 col-md-10 listado-pacientes-page">
        <div className="listado-pacientes-hero">
          <div className="listado-pacientes-hero-info">
            <div className="listado-pacientes-hero-icon">
              <i className="fas fa-users" />
            </div>
            <div>
              <h1 className="listado-pacientes-hero-title">Pacientes registrados</h1>
              <p className="listado-pacientes-hero-subtitle">
                Consulta el listado completo de pacientes del sistema
              </p>
            </div>
          </div>

          {Url.puedeExportarPacientesCsv() && (
            <div className="listado-pacientes-hero-export">
              <button
                type="button"
                className="listado-pacientes-export-btn"
                onClick={this.exportarCsv}
                disabled={this.state.exportandoCsv}
              >
                {this.state.exportandoCsv ? (
                  <><i className="fas fa-spinner fa-spin" /> Exportando…</>
                ) : (
                  <><i className="fas fa-file-csv" /> Exportar CSV</>
                )}
              </button>
            </div>
          )}

          <div className="listado-pacientes-total-card">
            <div className="listado-pacientes-total-icon">
              <i className="fas fa-user-check" />
            </div>
            <div className="listado-pacientes-total-content">
              <div className="listado-pacientes-total-label">Total registrados</div>
              <div className="listado-pacientes-total-num">
                {new Intl.NumberFormat('es-DO').format(this.state.cantidadRegistrados)}
              </div>
            </div>
          </div>
        </div>

        <div className="listado-pacientes-search-card">
          <div className="listado-pacientes-search-wrap">
            <div className="listado-pacientes-search-icon">
              <i className="fas fa-search" />
            </div>
            <input
              type="text"
              className="form-control listado-pacientes-search-input"
              placeholder={lang.buscar_paciente || 'Buscar por nombre, apellido, cédula o teléfono…'}
              value={this.state.terminoBusqueda}
              onChange={this.buscarPaciente}
            />
          </div>
        </div>

        <div className="listado-pacientes-table-card">
          <div className="listado-pacientes-paginador">{this.renderPaginador()}</div>
          <div className="table-responsive">
            <table className="table table-hover mb-0 listado-pacientes-table">
              <thead>
                <tr>
                  <th style={{ width: '52px' }} />
                  <th>#</th>
                  <th>{lang.nombre || 'Nombre'}</th>
                  <th>{lang.apellido || 'Apellido'}</th>
                  <th>{lang.doctor || 'Doctor'}</th>
                  <th>{lang.cedula || 'Cédula'}</th>
                  <th>{lang.telefono || 'Teléfono'}</th>
                  <th style={{ textAlign: 'right' }}>{lang.deuda || 'Deuda'}</th>
                  <th>Ingreso</th>
                  <th style={{ textAlign: 'center' }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {this.state.cargando && (
                  <tr>
                    <td colSpan="10" className="text-center py-5">
                      <img src={Loading} alt="Cargando" style={{ width: '48px' }} />
                    </td>
                  </tr>
                )}
                {!this.state.cargando && visibles.length === 0 && (
                  <tr>
                    <td colSpan="10" className="listado-pacientes-empty">
                      <i className="fas fa-inbox" />
                      No hay pacientes para mostrar
                    </td>
                  </tr>
                )}
                {!this.state.cargando && visibles.map((p, index) => {
                  const fila = (this.state.paginaActual - 1) * REGISTROS_POR_PAGINA + index + 1;
                  const deuda = p.estatus_precio_estatus_sum || 0;
                  return (
                    <tr key={p.id || index}>
                      <td style={{ padding: '12px 8px', width: '52px' }}>
                        {this.renderAvatarPaciente(p)}
                      </td>
                      <td style={{ color: '#94a3b8', fontWeight: 500 }}>{fila}</td>
                      <td>
                        <div className="listado-pacientes-nombre-cell">
                          {p.nombre || ''}
                        </div>
                      </td>
                      <td>{p.apellido || ''}</td>
                      <td style={{ color: '#64748b', fontSize: '14px' }}>
                        <i className="fas fa-user-md me-1" style={{ color: '#667eea', opacity: 0.7 }} />
                        {p.doctor ? `${p.doctor.nombre} ${p.doctor.apellido || ''}`.trim() : '—'}
                      </td>
                      <td style={{ color: '#64748b' }}>{p.cedula || '—'}</td>
                      <td style={{ color: '#64748b' }}>{p.telefono || '—'}</td>
                      <td style={{ textAlign: 'right' }}>
                        <span className={`listado-pacientes-deuda-badge ${deuda > 0 ? 'listado-pacientes-deuda-badge--deuda' : 'listado-pacientes-deuda-badge--ok'}`}>
                          ${new Intl.NumberFormat('es-DO').format(deuda)}
                        </span>
                      </td>
                      <td style={{ color: '#94a3b8', fontSize: '13px' }}>
                        {this.formatearFecha(p.fecha_de_ingreso)}
                      </td>
                      <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                        <Link
                          to={`/perfil_paciente/${p.id}/${p.id_doctor}`}
                          title="Ver perfil"
                          className="listado-pacientes-accion listado-pacientes-accion--perfil"
                        >
                          <i className="fa-solid fa-user-circle" />
                        </Link>
                        <Link
                          to={`/actualizar_paciente/${p.id}`}
                          title="Actualizar"
                          className="listado-pacientes-accion listado-pacientes-accion--editar"
                        >
                          <i className="fa-solid fa-pen-to-square" />
                        </Link>
                        <Link
                          to="/agregar_cita/"
                          title="Asignar cita"
                          className="listado-pacientes-accion listado-pacientes-accion--cita"
                        >
                          <i className="fa-solid fa-calendar-plus" />
                        </Link>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="listado-pacientes-paginador">{this.renderPaginador()}</div>
        </div>
      </div>
    );
  }
}

export default ListadoPacientes;
